import React from 'react';
import { usePageData } from '../../contexts/DataContext';
import LoadingSpinner, { LoadingSkeleton } from '../common/LoadingSpinner';
import { getIconComponent } from './FeaturesSection';

const SlipsSection = () => {
  const { data: homePage, isLoading, error } = usePageData('homePage');

  if (isLoading) {
    return (
      <section className="slip-section">
        <div className="slip-header">
          <LoadingSkeleton type="text" count={2} />
        </div>
        <div className="container">
          <div className="business-left">
            <LoadingSkeleton type="text" count={3} />
          </div>
          <div className="business-right">
            {[...Array(6)].map((_, i) => (
              <div className="card" key={i}>
                <LoadingSkeleton type="card" count={1} />
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  if (error || !homePage) {
    return (
      <section className="slip-section">
        <div className="slip-header">
          <h1>Professional Slip Generation Made Simple</h1>
          <p>
            Create accurate salary slips, payment receipts, and timesheet documents with our intuitive builder.
          </p>
        </div>
        <div className="container">
          <div className="business-left">
            <h2>Everything Your Business Needs</h2>
            <p>
              Whether you're a freelancer, small business owner, or HR professional, our slip builder helps you create professional documents in minutes.
            </p>
            <ul className="features">
              <li>✓ Automatic calculation of deductions and totals</li>
              <li>✓ Multiple currency and tax configuration support</li>
              <li>✓ Save templates for recurring monthly slips</li>
            </ul>
            <a className="primary-btn" href='/templates' style={{ textDecoration: 'none' }}>Create Your First Slip</a>
          </div>
          <div className="business-right">
            {[1, 2, 3, 4, 5, 6].map((i) => (
              <div className="card" key={i}>
                <div className="card-icon">📋</div>
                <h4>Slip Feature {i}</h4>
                <p>Description for slip feature {i}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="slip-section">
      <div className="slip-header">
        <h1>{homePage.slips_title}</h1>
        <p>{homePage.slips_subtitle}</p>
      </div>
      <div className="container">
        <div className="business-left">
          <h2>{homePage.slips_main_title}</h2>
          <p>{homePage.slips_description}</p>
          <ul className="features">
            <li>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="10" cy="10" r="10" fill="#3AA3F2"/>
                <path d="M5 12L7.72564 14.3363C8.15082 14.7007 8.79236 14.645 9.14836 14.2127L15.5 6.5" stroke="white" strokeLinecap="round"/>
              </svg>
              Automatic calculation of deductions and totals
            </li>
            <li>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="10" cy="10" r="10" fill="#3AA3F2"/>
                <path d="M5 12L7.72564 14.3363C8.15082 14.7007 8.79236 14.645 9.14836 14.2127L15.5 6.5" stroke="white" strokeLinecap="round"/>
              </svg>
              Multiple currency and tax configuration support
            </li>
            <li>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="10" cy="10" r="10" fill="#3AA3F2"/>
                <path d="M5 12L7.72564 14.3363C8.15082 14.7007 8.79236 14.645 9.14836 14.2127L15.5 6.5" stroke="white" strokeLinecap="round"/>
              </svg>
              Save templates for recurring monthly slips
            </li>
          </ul>
          <a className="primary-btn" href='/templates' style={{ textDecoration: 'none' }}>{homePage.slips_button_text}</a>
        </div>
        <div className="business-right">
          {homePage.slip_features?.map((slip, index) => {
            const IconComponent = getIconComponent(slip.icon);
            return (
              <div className="card" key={index}>
                <div className="card-icon">
                  <IconComponent />
                </div>
                <h4>{slip.title}</h4>
                <p>{slip.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default SlipsSection;